export type IDeviceType = 'desktop' | 'mobile';
export interface IDeviceInfo {
    deviceType: IDeviceType;
    isIOS: boolean;
}

const useDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    const deviceInfo = {
        deviceType: isMobile ? 'mobile' : 'desktop',
        isIOS
    }

    return deviceInfo;
}

// const useDeviceType = (): IDeviceInfo => {
//     const [deviceInfo, setDeviceInfo] = useState<IDeviceInfo>({
//         deviceType: 'desktop',
//         isIOS: false
//     });

//     useEffect(() => {
//         const handleCheckDevice = () => {
//             const userAgent = navigator.userAgent.toLowerCase();
//             const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
//             const isIOS = /iphone|ipad|ipod/.test(userAgent);

//             setDeviceInfo({
//                 deviceType: isMobile ? 'mobile' : 'desktop',
//                 isIOS
//             });
//         };

//         handleCheckDevice();
//         window.addEventListener('resize', handleCheckDevice);
//         return () => {
//             window.removeEventListener('resize', handleCheckDevice);
//         };
//     }, []);

//     return deviceInfo;
// };

export default useDeviceType;